<template>
	<div id='print_operation'>
    <el-button size="small" class='minButton' @click="exportHandler" v-if="showExport">导 出</el-button>
		<el-button
			type="default"
			size="mini"
			@click="printTotalDetail('1')">
			打印
		</el-button>
		<el-button
			v-if="showContinuit"
			type="default"
			size="mini"
			@click="openPrintDialog">
			连续打印
		</el-button>
		<el-dialog
		title='连续打印'
		class='default-dialog'
		:visible.sync="isShowPrint"
		:close-on-click-modal="false"
		width='380px'>
			<el-form ref="form" :model="form">
				<el-form-item label="打印方向：">
					<el-radio-group v-model="form.rotate">
				    	<el-radio label="1">纵向</el-radio>
				    	<el-radio label="2">横向</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item label="显示页码：">
					<el-checkbox v-model="form.showPage">显示打印页码</el-checkbox>
				</el-form-item>
				<el-form-item  label="科目类别：">
					<el-select v-model="form.subjectType" size="mini">
						<el-option
							v-for="item in subjectType"
							:key="item"
							:label="item"
							:value="item">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="isShowLevel" label="科目级别：">
					<el-select v-model="form.level" size="mini">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
		    	<el-button size="small" class="secondaryButton" @click="isShowPrint = false">取 消</el-button>
			    <el-button size="small" class='minButton' @click="confirm">打 印</el-button>
		  	</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'Print',
		props: {
			superSumBlean: {
				type: Boolean,
				default: true
			},
			formData: {
				type: Object,
				default: null
			},
			showContinuit: {
				type: Boolean,
				default: true
			},
			status: {
				type: String,
				default: 'total'
			},
			subjectType: {
				type: '',
				default: null,
			},
      showExport:{
        type: Boolean,
        default: false
      },
      exportApi:{
        type: String,
        default: ''
      },
      exportType:{
        type:Number,
        default:0
      }
		},
		data() {
			return {
				superSubjectId:'', // 科目ID
				printParams: {},  // 打印数据
				isShowLevel: true,
				isShowPrint: false,      // 连续打印弹框
				form: {
					rotate: "1",
					showPage: false,
					level: '5',
					subjectType: '全部'
				},
				options: [{
					value: '1',
					label: '一级'
				},{
					value: '2',
					label: '二级'
				},{
					value: '3',
					label: '三级'
				},{
					value: '4',
					label: '四级'
				},{
					value: '5',
					label: '五级'
				}],
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			// 连续打印
			openPrintDialog () {
				this.isShowPrint = true;
			},
			// 确认连续打印
			confirm() {
				this.isShowPrint = false;
				this.printParams = Object.assign({}, this.printParams, this.form);
				this.printTotalDetail('2');
			},
			// 打印
			printTotalDetail (type) {
				if(this.formData.data.subjectId) {
					this.superSubjectId = this.formData.data.subjectId;
				}
				if(this.superSubjectId) {
					if(type == 2) {
						this.formData.data.subjectId = '';
					}else if(type == 1){
						this.formData.data.subjectId = this.superSubjectId;
					}
				}
				this.printParams = Object.assign({}, this.printParams, this.formData.data, {
					cid: sessionStorage.cid,
					token: sessionStorage.token,
				})
				const router = this.$router.resolve({
					path: type === '1' ? this.formData.url : this.formData.continuityUrl,
					query: this.printParams
				})
				window.open(this.$rootUrl + router.href, '_blank')
			},
      // 导出
      exportHandler(){
        const params = {
          cid: sessionStorage.cid,
          token: sessionStorage.token,
          yearPeriods: this.formData.data.yearPeriods,
          type: this.exportType,
          showPage: 0
        };
        const router = this.$router.resolve({
          path: this.exportApi,
          query: params,
        });
        window.open(this.$rootUrl + router.href, "_blank");

      }
		}
	}
</script>
<style lang='less' scoped>
	#print_operation {
		display: inline-block;
		padding: 0 10px;
		.el-form {
			.el-form-item {
				margin-bottom: 15px;
			}
			.el-radio__inner {
				border-color: #269D7B;
   				background: #269D7B;
			}
			.el-radio__label {
				color: #269D7B !important;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/print/index.vue